import { useEffect } from "react";

const SITE = "https://www.vm-ffm.de";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/9cdaf805-ebb2-4698-b869-6dae56934adb/images/7f2da7ff5777324b0dbfeacc0f4c74a51d9416a4ebddd8fcffc96105f6371439.jpeg";

export default function Seo({ title, description, path = "", keywords, titleOverride, ogTitle, ogImage }) {
  useEffect(() => {
    const fullTitle = titleOverride || (title ? `${title} | VM-FFM.DE` : "VM-FFM.DE – Versicherung • Finanzierung • Immobilien");
    document.title = fullTitle;
    const socialTitle = ogTitle || fullTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("name", "robots", "index, follow");
    if (keywords) setMeta("name", "keywords", keywords);

    setMeta("property", "og:site_name", "VMF Versicherungsmakler Frankfurt");
    setMeta("property", "og:title", socialTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "de_DE");
    setMeta("property", "og:image", ogImage || OG_IMAGE);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:image:alt", "VMF Versicherungsmakler Frankfurt – Sorglos und sicher in Ihre Zukunft.");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", socialTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage || OG_IMAGE);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", `${SITE}${path}`);
  }, [title, description, path, keywords, titleOverride, ogTitle, ogImage]);
  return null;
}
